import StepDrawer from './StepDrawer';
import React, { useState, useEffect } from 'react';

function NoteSelector({
    notes,
    setNotes,
    onCancel,
    currentStep,
    totalSteps,
    onContinue,
    onBack,
    submitting,
    isEdit
}) {
    return (
        <StepDrawer
            currentStep={currentStep}
            totalSteps={totalSteps}
            onCancel={onCancel}
            onContinue={onContinue}
            onBack={onBack}
            title={isEdit ? "Edit Pain Diary Entry" : "New Pain Diary Entry"}
            disabled={submitting}
        >
            <div className="form-content">
                <div className="review-row">
                    <div className="review-label">
                        Notes:
                    </div>
                </div>
                <div className="review-row-large">
                    <textarea
                        className="review-value"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)
                        }
                    />
                </div>
            </div>
        </StepDrawer>
    )
}

export default NoteSelector